// extracted by css-extract-rspack-plugin
export default {"yourBidText":"_af27e87","noWrap":"_a4e4b11"};